<template>
  <div id="history">
    <b-navbar type="light" variant="light-success">
      <b-button v-b-toggle.sidemenu variant="outline-secondary" class="mr-2 d-lg-none"><f-icon icon="bars"></f-icon></b-button>
      <b-navbar-brand  class="mb-0" :to="{ path: '/ld' }" replace>
        <img :src="logoImg" class="d-inline-block align-top" alt="Logo" height="30px">
        {{ logoName }}
      </b-navbar-brand>
    </b-navbar>
    <b-sidebar id="sidemenu" title="Menu" body-class="px-2" shadow>
      <left-menu></left-menu>
    </b-sidebar>
    <b-container fluid class="bg-white shadow-sm">
      <b-row>
        <b-col cols="3" class="d-none d-lg-block pb-4 pt-2">
          <left-menu></left-menu>
        </b-col>
        <b-col lg="9" class="pt-4 pb-4 animate__animated animate__fadeIn">

          <h2>แดชบอร์ด</h2>
          <b-card-group deck>
            <!-- <b-col> v-if="dataReady && dashboard.vipName" -->
              <b-card bg-variant="gra-ye-gr"
              class="text-center mb-2 border-transparent-app"  >
                <template v-if="dataReady && dashboard.vipName">
                  <h4>VIP Member</h4>
                  <h2 class="mb-0">
                    <img :src="picSVG[dashboard.vipName]" class="icon-svg"/>
                    {{ dashboard.vipName }}
                  </h2>
                </template>

                <template v-if="dataReady && !dashboard.vipName">
                  <h4>แต้มสะสมของคุณ</h4>
                  <h3 class="mb-0">
                    <img :src="require('@/assets/svg/chip_point.svg')" class="icon-svg"/> {{ dashboard.pointBalance }} แต้ม
                  </h3>
                </template>

                <h2 v-if="!dataReady"><f-icon icon="spinner" pulse></f-icon></h2>
              </b-card>
            <!-- </b-col> -->
            <!-- <b-col> -->
              <b-card bg-variant="gra-gr-bl" class="text-center mb-2 border-transparent-app">
                <h4>ยอดเงินขนส่งจีน-ไทย</h4>
                <h3 v-if="dataReady">
                  <img :src="require('@/assets/svg/shippingMoney.svg')" class="icon-svg" /> 
                  {{ dashboard.cashBalance }} บาท
                </h3>
                <h2 v-if="!dataReady"><f-icon icon="spinner" pulse></f-icon></h2>
              </b-card>
            <!-- </b-col> -->
            <!-- <b-col> -->
              <!-- <b-card bg-variant="gra-ye-pu" class="text-center mb-2 border-transparent-app">
                <h4>ยอดเงินสั่งสินค้า</h4>
                <h3 v-if="dataReady">
                  <img :src="require('@/assets/svg/preMoney.svg')" class="icon-svg" /> {{ dashboard.preBalance }} บาท
                </h3>
                <h2 v-if="!dataReady"><f-icon icon="spinner" pulse></f-icon></h2>
              </b-card> -->
            <!-- </b-col> -->
          </b-card-group>
          <br />
          <b-card-group deck>

            <b-card bg-variant="light">
              <b-card-text>
                <label for="form_name" class="mb-1"><b>ชื่อผู้รับ:</b></label>
                {{dashboard.firstName + ' ' + dashboard.lastName}} <br />
                <label class="mb-1"><b>ที่อยู่จัดส่ง:</b></label>
                {{dashboard.address}} <br />
                <label for="form_tel" class="mb-1"><b>เบอร์โทรศัพท์ผู้รับ:</b></label>
                {{dashboard.telephoneNumber}}
              </b-card-text>
              <b-card-text>
                <b>ที่อยู่โกดังจีน:</b>  <br>
                  <!-- 收货人：{{ userData.userCode }} <br>
                  广东省 广州市 白云区 白云湖街道 <br>
                  夏茅南约商业街18号仓库1112-1 1688仓库 ({{ userData.userCode }}) <br>
                  邮编：510000 <br>
                  电话：17819689816 -->

                  收货人：({{ userData.userCode }})<br>
                  所在地区：广东省  广州市  白云区 白云湖街道<br>
                  详细地址 :  机场路 2721号 广花货运场 D区118号LICM 仓库 ({{ userData.userCode }}) 510000<br>
                  手机：17819689816
              </b-card-text>
            </b-card>

            <b-card body-class="p-0">
              <b-card-body class="p-0">
                <table class="table mb-0">
                  <thead class="table-bordered thead-light text-center">
                    <tr>
                      <th scope="col" rowspan="2">ประเภทสินค้า</th>
                      <th scope="col" colspan="2">ราคาต่อ</th>
                    </tr>
                    <tr>
                      <th scope="col">กิโลกรัม</th>
                      <th scope="col">คิว</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">สินค้าทั่วไป</th>
                      <td>{{priceShipping.generalKilo}}</td>
                      <td>{{priceShipping.generalQueue}}</td>
                    </tr>
                    <tr>
                      <th scope="row">สินค้า มอก./ของเล่น</th>
                      <td>{{priceShipping.tisKilo}}</td>
                      <td>{{priceShipping.tisQueue}}</td>
                    </tr>
                    <tr>
                      <th scope="row">สินค้า อย.</th>
                      <td>{{priceShipping.fdaKilo}}</td>
                      <td>{{priceShipping.fdaQueue}}</td>
                    </tr>
                    <tr>
                      <th scope="row">สินค้าลิขสิทธิ์/พิเศษ</th>
                      <td>{{priceShipping.copyrightKilo}}</td>
                      <td>{{priceShipping.copyrightQueue}}</td>
                    </tr>
                    <tr>
                      <th scope="row">สินค้าควบคุมพิเศษ</th>
                      <td>{{priceShipping.specialControlKilo}}</td>
                      <td>{{priceShipping.specialControlQueue}}</td>
                    </tr>
                  </tbody>
                </table>
              </b-card-body>
            </b-card>

          </b-card-group>
          <br />
          <alert-card></alert-card>
        </b-col>
      </b-row>
    </b-container>

    <b-modal id="modalPromote" ok-only hide-header centered body-class="p-0">
      <b-img src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/001.jpeg?alt=media&token=6aadc097-0b5e-4b3e-84de-a171118fa978" fluid alt="Promote image" @load="onImgLoad"></b-img>

      <template #modal-footer="{ }">
        <div class="footer-space-between">
          <b-form-checkbox v-model="isClose" name="check-button-promote" v-if="isLoaded">
            ไม่แสดงอีก (1 วัน)
          </b-form-checkbox>
          <!-- Button with custom close trigger value -->
          <b-button size="sm" variant="outline-secondary" @click="setTimeEnd()" v-if="isLoaded">
            ปิดหน้าต่าง
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-container fluid class="text-center mt-3 mb-2">
      {{ footerLC }}
    </b-container>
  </div>
</template>

<script>
import axios from "axios"; // api
import MenuBar from '@/components/Menubar' // เมนู
import AlertCard from '@/components/Alert' // แจ้งเดือน
export default {
  name: "Tracking",
  components: {
    'left-menu': MenuBar,
    'alert-card': AlertCard
  },
  beforeCreate() {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
  },
  created() {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
    // setInterval(this.getDataMap, 1000)
  },
  async mounted() {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    await this.getDataUser();
    this.getClosePromote()
    this.priceShipping = this.priceByQueueOrKilo
  },
  data() {
    return {
      userData: {
        userName: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        userType: ''
      },
      priceShipping: {},
      dashboard: {
        userId: '',
        userCode: '',
        userType: '',
        userName: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        address: '',
        preBalance: '0',
        cashBalance: '0',
        vipName: '',
        pointBalance: '0',
      },
      dataReady: true,
      isClose: false,
      isLoaded: false,
    };
  },
  methods: {
    getDataUser() {
      this.dataReady = false;
      let lsUser = this.getDataStorageUser()
      if (lsUser) {
        this.userData = lsUser
        this.getDataProfile(lsUser.userName)
      } else {
        this.$router.push('/Login')
      }
    },
    onImgLoad () {
      this.isLoaded = true
    },
    getClosePromote () {
      // const promoteSession = this.$session.get('crp')
      const promoteSession = localStorage.getItem('crp')
      const dataTimeNow = new Date().getTime()
      if (promoteSession) {
        console.log(promoteSession, promoteSession > dataTimeNow)
        // this.closePromote = promoteSession > dataTimeNow
        if (promoteSession > dataTimeNow) {
          this.$bvModal.hide('modalPromote')
        } else {
          localStorage.removeItem('crp')
        }
      } else {
        this.$bvModal.show('modalPromote')
      }
    },
    setTimeEnd() {
      if (this.isClose) {
        const dataTimeEnd = new Date()
        dataTimeEnd.setHours(23)
        dataTimeEnd.setMinutes(59)
        dataTimeEnd.setSeconds(59)
        localStorage.setItem('crp', dataTimeEnd.getTime())
      }

      this.$bvModal.hide('modalPromote')
    },
    getDataProfile(dt) {
      this.dataReady = false;
      axios
        .get(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/User/user_list?userName="+dt,
          {
            headers: this.getHeaderAPI('User_list', dt)
          }
        )
        .then((response) => {
          let rs = response.data
          if (rs.status === true){
            let data = rs.data[0]
            this.dashboard.userId = data.userId
            this.dashboard.userCode = data.userCode
            this.dashboard.userName = data.userName
            this.dashboard.firstName = data.firstName
            this.dashboard.lastName = data.lastName
            this.dashboard.telephoneNumber = data.telephoneNumber
            this.dashboard.address = data.address
            this.dashboard.userType = data.userType

            this.dashboard.preBalance = data.preBalance
            this.dashboard.cashBalance = data.cashBalance

            this.dashboard.pointBalance = data.point

            this.dataReady = true;

            if (this.dashboard.userCode) {
              this.getDataVIP(this.dashboard.userCode)
            } else {
              // this.$swal("ผิดพลาด", "ไม่พบรหัสสมาชิกของท่าน กรุณาติดต่อแอดมิน", "error")
            }
          } else {
            this.$swal("ผิดพลาด","ไม่สามารถดึงข้อมูลส่วนตัวได้","error")
            this.dataReady = true;
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true;
          // this.errored = true
        });
    },
    getDataVIP (userCode) {
      this.dataReady = false;
        axios
          .get(
            // eslint-disable-next-line quotes
            'https://licm-cargo.com/api/Vip/Vip_user?userCode=' +
            userCode,
            {
              headers: { 'application-key' : 'T2FLZ#Xo:!WJ%qnC+jPf(U&EkHDi_K8V*S(QKb)!Rcqd6XI8pOyl_unZWN2PS,E*1r=f*eL7E:4%;6y@I.)$!P_xHCnh,q3AKU#tap' }
            }
          )
          .then((response) => {
            // console.log('getDataVipUser', response.data)

            let rs = response.data
            if (rs.status === true){
              this.dashboard.vipName = rs.data.vipName
              this.priceShipping = rs.data
              this.dataReady = true
            } else {
              this.getDataUserPoint()
            }
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            this.$swal("ผิดพลาด", "getDataVIP error", "error")
            console.log('getDataVIP error:', error)
            this.dataReady = true
            this.dataVipReady = true
          });
    },
    getDataUserPoint () {
      this.dataReady = false
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/User/User_point?userName=' +
          this.userData.userName,
          {
            headers: this.getHeaderAPI('User_point', this.userData.userName)
          }
        )
        .then((response) => {
          let rs = response.data
          console.log('getDataUserPoint', response.data)
          if (rs.status === true){
            this.dashboard.pointBalance = parseInt(rs.point)
            this.dataReady = true;
          } else {
            this.dashboard.pointBalance = 0
            this.dataReady = true;
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dashboard.pointBalance = 0
          this.$swal("ผิดพลาด","ไม่สามารถดูแต้มส่วนลดของท่าน กรุณาติดต่อแอดมิน","error")
          this.dataReady = true;
          // this.errored = true
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#form-profile {
  text-align: left;
}

div.language-bar {
  padding-top: 10px;
  padding-bottom: 10px;
}

.footer-space-between {
  justify-content: space-between;
  width: 95%;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/User/Dashboard.vue